import { fullCircleDeg, halfCircleDeg } from '../constants';

type DragSpeedOptions = {
  height: number;
  wheelSize: number;
  slidesPerView: number;
  speed: number;
  speedMultiplier: number;
};

export const getDragSpeed = ({
  height,
  wheelSize,
  slidesPerView,
  speed,
  speedMultiplier,
}: DragSpeedOptions): number => {
  const slideDegree = fullCircleDeg / wheelSize;

  const adjustedDistance =
    height / ((height / 2) * Math.tan(slideDegree * (Math.PI / halfCircleDeg))) / slidesPerView;

  return speed * adjustedDistance * speedMultiplier;
};
